import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	header: {
		textAlign: 'center',
		padding: '8px 10px',
		fontSize: '26px',
		lineHeight: '39px',
		fontWeight: 700,
		color: '#595959',
	},
	title: {
		textAlign: 'center',
		fontSize: '14px',
		marginTop: '20px',
	},
};

class ValidationDialog extends React.Component {
	render() {
		const {
			totalEmailsCount,
			addedEmailsCount,
			invalidEmails,
			classes,
		} = this.props;

		const invalidEmailsCount = invalidEmails.length;

		const hasInvalidEmails = invalidEmailsCount > 0;

		return (
			<div>
				<div className={classes.header}>
					Upload completed!
				</div>
				<div className={classes.title}>
					{addedEmailsCount} unique Emails out of {totalEmailsCount} uploaded successfully!
				</div>
				{
					hasInvalidEmails &&
					<div>
						<div className={classes.title}>
							Failed to upload the following {invalidEmailsCount} emails, due to the format:
						</div>
						<ul>
							{
								invalidEmails.map((item, index) => (
									<li key={index}>
										<b>{item}</b>
									</li>
								))
							}
						</ul>
					</div>
				}
			</div>
		);
	}
}

export default withStyles(styles)(ValidationDialog);
